/* eslint-disable */
export default {
  noActiveCalls: 'Aucun appel actif',
  noCalls: 'Aucun résultat trouvé.',
  currentCall: 'Appel en cours',
  ringCall: 'Appel entrant',
  onHoldCall: 'Appel en attente',
  historyCalls: 'Appels passés',
  otherDeviceCall: 'Appels en cours sur mes autres appareils',
  searchPlaceholder: 'Recherche…',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
